import icMinus from "@/assets/icons/ic-minus.svg";
import icTrendDown from "@/assets/icons/ic-arrow-down.svg";
import icTrendUp from "@/assets/icons/ic-arrow-up.svg";

/** Map a trend direction to the icon and color tokens. */
export const TREND_STYLES = {
  up: { icon: icTrendUp, classes: "bg-[#43946C] text-[#000000]" },
  down: { icon: icTrendDown, classes: "bg-[#E54D2E ] text-[#000000]" },
  neutral: { icon: icMinus, classes: "bg-[#EBEBEB] text-[#000000]" },
} as const;
